import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { TextField, Button, Typography, Box, Container, Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";
import apiClient from "../api/apiClient";

const Register = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    username: "",
    privatecode: "",
  });
  const [message, setMessage] = useState("");
  const [openDialog, setOpenDialog] = useState(false); // สำหรับควบคุม modal

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // ตรวจสอบ password ตรงกันหรือไม่
    if (formData.password !== formData.confirmPassword) {
      setMessage("Passwords do not match!");
      setOpenDialog(true); // เปิด dialog
      return;
    }
  
    // ตรวจสอบ private code
    if (formData.privatecode !== "EWY") {
      setMessage("Private code do not match! Please contact aiscimer.");
      setOpenDialog(true); // เปิด dialog
      return;
    }
  
    try {
      const { email, password, username } = formData;
      const dataToSend = { email, password, username, role: "staff" };
  
      // ส่ง request ไปยัง backend
      const response = await apiClient.post(
        "/auth/register", // เส้นทางที่ backend ของคุณรับการร้องขอ
        dataToSend // ข้อมูลที่ต้องการส่ง
      );
  
      // เก็บ token จาก backend (ถ้ามี)
      if (response.data.token) {
        localStorage.setItem("token", response.data.token);
      }
  
      // แสดงข้อความสำเร็จ
      setMessage("Registration successful! Please log in.");
      setOpenDialog(true);
  
      // นำทางไปหน้า Home
      // navigate("/home");
      setTimeout(() => navigate("/home"), 1000); // รอ 1 วินาทีแล้วนำทาง
    } catch (error) {
      // แสดง error จาก backend
      const errorMessage =
        error.response?.data?.error || "Registration failed. Please try again.";
      setMessage(errorMessage);
      setOpenDialog(true);
    }
  };
  

  const handleCloseDialog = () => {
    setOpenDialog(false); // ปิด dialog
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 3,
          borderRadius: 2,
          boxShadow: 3,
          backgroundColor: "background.paper",
        }}
      >
        <Typography variant="h5" gutterBottom>
          Register
        </Typography>

        <form onSubmit={handleSubmit} style={{ width: "100%" }}>
          <TextField
            fullWidth
            label="Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            margin="normal"
            required
            type="email"
          />

          <TextField
            fullWidth
            label="Password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            margin="normal"
            required
            type="password"
          />

          <TextField
            fullWidth
            label="Confirm Password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            margin="normal"
            required
            type="password"
          />

          <TextField
            fullWidth
            label="Name"
            name="username"
            value={formData.username}
            onChange={handleChange}
            margin="normal"
            required
          />

          <TextField
            fullWidth
            label="Private Code"
            name="privatecode"
            value={formData.privatecode}
            onChange={handleChange}
            margin="normal"
            required
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 3, mb: 2 }}
          >
            Register
          </Button>
        </form>
        <Typography variant="body2" color="text.secondary">
          Private Code. Please contact{" "}
          <Link to="https://www.aiscimer.com/">aiscimer</Link>
        </Typography>
      </Box>

      {/* Modal Dialog */}
      <Dialog open={openDialog} onClose={handleCloseDialog} disableEnforceFocus>
      {/* Title */}
      <DialogTitle 
        sx={{ 
          backgroundColor: "#1976d2",
          color: "white", 
          fontSize: "1rem", 
          fontWeight: "bold",
          textAlign: "center",
          padding: "8px",
          minHeight: "20px",
          // borderTopLeftRadius: "8px",
          // borderTopRightRadius: "8px",
          }}>
        Notification
      </DialogTitle>
      {/* Content */}
      <DialogContent
        sx={{
          display: "flex", // ใช้ Flexbox
          flexDirection: "column", // จัดเรียงในแนวตั้ง
          alignItems: "center", // จัดตรงกลางแนวนอน
          justifyContent: "center", // จัดตรงกลางแนวตั้ง
          minHeight: "50px", // ตั้งความสูงของ Content
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem", // กำหนดขนาดฟอนต์ใน content
            color: "#333", // สีข้อความ
            ineHeight: "1",
            textAlign: "center",
          }}
        >
        {message}</Typography>
        </DialogContent>
        {/* Actions */}
        <DialogActions
          sx={{
            display: "flex", // ใช้ Flexbox
            justifyContent: "center", // จัดปุ่ม OK ให้อยู่กลาง
            paddingBottom: "8px", // เพิ่มระยะห่างด้านล่าง
          }}
        >
          <Button
            onClick={handleCloseDialog}
            variant="contained"
            color="primary"
            sx={{
              // minWidth: "100px", // ขนาดความกว้างขั้นต่ำ
              fontSize: "0.9rem", // ขนาดฟอนต์ของปุ่ม
            }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default Register;
